const testimonials = [
  {
    name: "Marcus D.",
    location: "Lafayette Energy Corridor, LA",
    rating: 5,
    text: "I am a subsea engineer at a Lafayette-based company and received rotation confirmation to Angola with 11 days before my flight. My passport had less than five months validity — Angola requires six. Fast Passport Center reviewed my documents, got the renewal expedited, and I had my new passport in six business days. Made my flight from New Orleans. This service is essential for anyone in the oilfield.",
    service: "Emergency Renewal",
  },
  {
    name: "Camille B.",
    location: "Youngsville, LA",
    rating: 5,
    text: "My daughter received acceptance to a ULL study-abroad program in Paris and her passport had expired. It was her first renewal as an adult and I did not know what the process required. Fast Passport Center walked us through exactly what to do, we shipped overnight from Youngsville, and had her renewed passport in seven business days. She made her orientation departure. Could not be more grateful.",
    service: "Passport Renewal",
  },
  {
    name: "The Fontenot Family",
    location: "Broussard, LA",
    rating: 5,
    text: "We booked a Caribbean cruise out of New Orleans for our family of four and realized two weeks before sailing that my son had never gotten a passport. He was 14. Fast Passport Center explained the child passport process step by step, we visited the acceptance clerk in Lafayette, and shipped the next morning. Had his passport with four days to spare before we drove to New Orleans. Absolute lifesavers.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function LafayetteTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Acadiana Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Lafayette, Youngsville, and Broussard travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}